module.exports = __webpack_public_path__ + "static/media/coins.ddc44445.png";